import Vue from "vue";
import * as Sentry from "@sentry/vue";

function initAndGetSentryConfig(sentryConfigUrl) {
	return new Promise(function (resolve, reject) {
		const scriptTag = document.createElement("script");
		// eslint-disable-next-line no-undef
		scriptTag.src = sentryConfigUrl;
		scriptTag.type = "text/javascript";
		// eslint-disable-next-line no-undef
		scriptTag.onload = () => resolve(sentryConfig);
		scriptTag.onerror = reject;
		document.head.appendChild(scriptTag);
	});
}

async function initSentry() {
	const parentWindowUrl = location.hostname;

	if (!parentWindowUrl.includes("chamaileon.io")) {
		return;
	}

	let environmentName = "dev";

	if (parentWindowUrl.includes("app.chamaileon.io")) {
		environmentName = "prod";
	} else if (parentWindowUrl.includes("app-santander.chamaileon.io")) {
		environmentName = "prod-santander";
	} else if (parentWindowUrl.includes("app-staging.chamaileon.io")) {
		environmentName = "staging";
	} else if (parentWindowUrl.includes("app-test.chamaileon.io")) {
		environmentName = "test";
	}

	let sentryConfigUrl;

	// LOAD CONFIGURATION FILES
	if (environmentName !== "dev") {
		sentryConfigUrl = "https://cdn.chamaileon.io/assets/sentryConfig.js";
	}

	const sentryConfig = await initAndGetSentryConfig(sentryConfigUrl);

	if (sentryConfig
		&& (sentryConfig.excludedEnvs && !sentryConfig.excludedEnvs.includes(environmentName))
		&& (sentryConfig.excludedDomains && !sentryConfig.excludedDomains.some(domain => parentWindowUrl.includes(domain)))) {
		Sentry.init({
			...sentryConfig.basicConfig,
			ignoreErrors: sentryConfig.ignoreErrors,
			denyUrls: sentryConfig.denyUrls,
			// add these to the front so we can overwrite them with local values if needed
			Vue,
			dsn: "https://c699bee3d8f44c97a85ecace852b8c44@o267489.ingest.sentry.io/5877004",
			integrations: [ Sentry.browserTracingIntegration() ],
			debug: false,
			release: `chamaileon-app@${__APP_VERSION__}`,
			environment: environmentName,
		});
	}
}

export default initSentry;
